import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import ClientAutocomplete from "../clientAutocomplete";
import { supplierClientMapService } from "../../utils/services/supplier-client-map.service";
import AutocompleteWithPagination from "../autocomplete-with-pagination";
import { supplierService } from "../../utils/services/supplierService";
import buildQuery from "../../utils/query-builder";
import CustomTypography from "../../globalStyles/fonts";

const SupplierClientMapModal = ({
  open,
  handleClose,
  onAddData,
  selectedClientMapping,
}) => {
  const [formData, setFormData] = useState({
    supplier: null,
    client: null,
  });
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = () => {
    const errors = {};

    if (!formData.client) {
      errors.client = " Client is required";
    }
    if (!formData.supplier) {
      errors.supplier = "Supplier is required";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (selectedClientMapping) {
      setFormData({
        client: selectedClientMapping.client?.business_name || null,
        supplier: selectedClientMapping.supplier?.name || null,
      });
      setSelectedClient(selectedClientMapping.client || null);
      setSelectedSupplier(selectedClientMapping.supplier || null);
    } else {
      resetForm();
    }
  }, [selectedClientMapping]);

  const resetForm = () => {
    setFormData({
      client: null,
      supplier: null,
    });
    setSelectedClient(null);
    setSelectedSupplier(null);
    setFormErrors({});
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await supplierClientMapService.create({
        client: formData.client?._id,
        supplier: formData.supplier?._id,
      });
      toast.success("Client mapping created successfully!");
      onAddData && onAddData();
      handleClose();
      resetForm();
    } catch (e) {
      toast.error("Failed to create client mapping.");
      console.error(e);
    }
  };
  const handleEditData = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await supplierClientMapService.edit(selectedClientMapping._id, {
        client: formData.client?._id,
        supplier: formData.supplier?._id,
      });
      onAddData && onAddData();
      toast.success("Client mapping edited successfully!");
      resetForm();
    } catch (e) {
      toast.error("Failed to edited partner.");
      console.error(e);
    }
    resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose();
        resetForm();
      }}
      maxWidth="xl"
      aria-labelledby="form-dialog-title"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontFamily: "Poppins",
            fontSize: 24,
            fontWeight: 500,
            color: "var(--text-primary)",
          }}
        >
          {selectedClientMapping ? "Edit" : "Create"} Supplier Client Mapping
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CustomTypography>Client</CustomTypography>

            <ClientAutocomplete
              hideLabel
              backgroundColor={"var(--bg-paper)"}
              label="Choose Client"
              selectedClient={selectedClient}
              onClientChange={(client) => {
                setSelectedClient(client);
                setFormData((prev) => ({ ...prev, client: client }));
              }}
              errorMessage={formErrors.client}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <CustomTypography>Supplier</CustomTypography>

            <AutocompleteWithPagination
              backgroundColor={"var(--bg-paper)"}
              customLabel={"Supplier"}
              hideLabel
              selectedItem={selectedSupplier}
              onDataChange={(supplier) => {
                if (supplier) {
                  setSelectedSupplier(supplier);
                  setFormData((prev) => ({ ...prev, supplier: supplier }));
                } else {
                  setSelectedSupplier(null);
                  setFormData((prev) => ({ ...prev, supplier: "" }));
                }
              }}
              width={"98%"}
              optionKey={"name"}
              apiEndPoint={(limit, skip, search, client) => {
                const query = buildQuery({ limit: limit, skip: skip });
                return supplierService.fetch(search, client, query);
              }}
            ></AutocompleteWithPagination>
            {/* <SupplierAutocomplete
              backgroundColor={'#FFF'}
              selectedSupplier={selectedSupplier}
              onSupplierChange={(supplier) => {
                setSelectedSupplier(supplier)
                setFormData((prev) => ({ ...prev, supplier: supplier }))
              }}
              errorMessage={formErrors.supplier}
            /> */}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            handleClose();
            resetForm();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={(e) =>
            selectedClientMapping ? handleEditData(e) : handleSave(e)
          }
          color="primary"
          variant="contained"
        >
          {selectedClientMapping ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupplierClientMapModal;
